<template>
  <div class="form__input form__input--radio"
       :class="{'form__input--error': data.error}">
    <div class="form__input__wrap">
      <label v-word="labelWord" />
      <div>
        <div class="radio-group">
          <template v-for="opt in opts">
            <input :key="opt.val + '-input'"
                   v-model="val"
                   :name="createId()"
                   :id="createId(opt.val)"
                   type="radio"
                   :value="opt.val">
            <label :key="opt.val + '-label'"
                   :for="createId(opt.val)"
                   v-word="opt.titleWord" />
          </template>
        </div>
        <p v-if="data.error"
           class="form__input__error">{{ data.error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import wordDirective from '../directives/word';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  props: [
    'data',
    'labelWord',
    'wordingsEditable',
    'wordings',
    'wordingsMeta',
    'opts',
  ],
  data() {
    return {
      idBase: Math.random(),
    };
  },
  computed: {
    val: {
      get() {
        return this.data.val;
      },
      set(val) {
        this.$emit('change', val, this.data.valName);
      },
    },
  },
  methods: {
    createId(val) {
      return '' + val + '__' + this.idBase;
    },
  },
  directives: {
    word: wordDirective,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InputRadio.vue